<script>
    // ═══ Карточка капта в худе ═══
    // Показывается, пока идёт бой за территорию: счёт убийств, сколько бойцов
    // осталось в зоне и таймер. Данные — штатные события боя (table/war.js):
    // hud.war.open / hud.war.update / hud.war.close. Положение настраивается в
    // редакторе худа (блок «capture»).
    import { fly } from 'svelte/transition';
    import { addListernEvent } from 'api/functions';
    import { hudEditMode } from 'store/hudlayout';
    import HudBox from './hudbox.svelte';

    let visible = false;
    let demo = false;

    let title = '';
    let attackName = '';
    let protectingName = '';
    let time = '00:00';
    let attackingCount = 0;
    let protectingCount = 0;
    let attackingInZone = 0;
    let protectingInZone = 0;

    addListernEvent('hud.war.open', (_warType, _gripType, _weaponType, _title, _attackName, _protectingName) => {
        title = _title || 'Капт территории';
        attackName = _attackName || 'Нападение';
        protectingName = _protectingName || 'Защита';
        visible = true;
    });

    addListernEvent('hud.war.update', (type, value1, value2) => {
        if (type === 'count') {
            attackingCount = value1;
            protectingCount = value2;
        } else if (type === 'playersCount') {
            attackingInZone = value1;
            protectingInZone = value2;
        } else if (type === 'time') {
            time = value1;
        }
    });

    addListernEvent('hud.war.close', () => {
        visible = false;
        attackingCount = protectingCount = attackingInZone = protectingInZone = 0;
    });

    // примерка блока в редакторе худа
    window.hudStore = window.hudStore || {};
    window.hudStore.demoCapture = () => {
        demo = true;
        title = 'Территория #12';
        attackName = 'Ballas';
        protectingName = 'Families';
        attackingCount = 4;
        protectingCount = 6;
        attackingInZone = 5;
        protectingInZone = 7;
        time = '07:41';
    };

    $: if (!$hudEditMode) demo = false;
    $: show = visible || demo;
    $: total = attackingCount + protectingCount;
    $: attackShare = total ? (attackingCount / total) * 100 : 50;
</script>

{#if show}
    <HudBox id="capture" label="капт">
        <div class="lcw" transition:fly={{ x: -16, duration: 260 }}>
            <div class="lcw__hairline"></div>

            <div class="lcw__head">
                <span class="lcw__kicker">◆ Война за территорию</span>
                <span class="lcw__time">{time}</span>
            </div>

            <div class="lcw__title">{title}</div>

            <div class="lcw__score">
                <div class="lcw__side">
                    <div class="lcw__name">{protectingName}</div>
                    <div class="lcw__num">{protectingCount}</div>
                    <div class="lcw__alive">в зоне: {protectingInZone}</div>
                </div>
                <div class="lcw__vs">:</div>
                <div class="lcw__side right">
                    <div class="lcw__name">{attackName}</div>
                    <div class="lcw__num">{attackingCount}</div>
                    <div class="lcw__alive">в зоне: {attackingInZone}</div>
                </div>
            </div>

            <div class="lcw__bar">
                <span class="def" style="width:{100 - attackShare}%"></span>
                <span class="atk" style="width:{attackShare}%"></span>
            </div>
        </div>
    </HudBox>
{/if}

<style>
    .lcw {
        position: relative;
        width: 30vh;
        padding: 1.5vh 1.8vh 1.6vh;
        border-radius: 1.1vh;
        background: rgba(12, 12, 14, .82);
        backdrop-filter: blur(1.2vh);
        font-family: 'SF Pro Display', sans-serif;
        color: #F2F0EB;
    }
    .lcw__hairline {
        position: absolute; left: 1.8vh; right: 1.8vh; top: 0; height: .12vh;
        background: linear-gradient(90deg, rgba(231, 174, 63, 0), #E7AE3F, rgba(231, 174, 63, 0));
    }
    .lcw__head { display: flex; align-items: center; justify-content: space-between; }
    .lcw__kicker {
        font-size: .95vh; font-weight: 600; letter-spacing: .14vh;
        text-transform: uppercase; color: #E7AE3F;
    }
    .lcw__time { font-size: 1.5vh; font-weight: 600; font-variant-numeric: tabular-nums; }
    .lcw__title { margin-top: .5vh; font-size: 1.35vh; font-weight: 500; color: rgba(242, 240, 235, .5); }

    .lcw__score { display: flex; align-items: flex-end; gap: 1vh; margin-top: 1.2vh; }
    .lcw__side { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: .2vh; }
    .lcw__side.right { align-items: flex-end; text-align: right; }
    .lcw__name {
        font-size: 1.05vh; font-weight: 600; letter-spacing: .1vh; text-transform: uppercase;
        color: rgba(242, 240, 235, .45); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%;
    }
    .lcw__num { font-size: 2.6vh; font-weight: 600; line-height: 1; font-variant-numeric: tabular-nums; }
    .lcw__alive { font-size: 1vh; font-weight: 500; color: rgba(242, 240, 235, .35); }
    .lcw__vs { font-size: 2vh; font-weight: 600; color: rgba(242, 240, 235, .3); padding-bottom: 1.4vh; }

    .lcw__bar {
        display: flex; height: .5vh; margin-top: 1.2vh;
        border-radius: 3vh; overflow: hidden; background: rgba(255, 255, 255, .06);
    }
    .lcw__bar span { display: block; height: 100%; }
    .lcw__bar .def { background: #6CC28A; }
    .lcw__bar .atk { background: #C4342F; }
</style>
